import { useLocation } from '@reach/router';
import { List } from 'antd';
import { navigate, withPrefix } from 'gatsby';
import React, { useEffect, useState, useContext } from 'react';

import ListItemCount from '../components/ListItemCount';
import { BlogType } from '../models/blog';
import { SearchContext } from '../store/SearchContext';
import { countPostsInCategory } from '../utils/search';
import { SITE_CONFIG, PostCategory } from '../utils/site';

type CategoryCount = PostCategory & {
  count?: number;
};

const CategoryListContainer: React.FC = () => {
  const blogType = process.env.GATSBY_BLOG_TYPE as BlogType;
  const [categories, setCategories] = useState(
    SITE_CONFIG[blogType].categories as CategoryCount[]
  );

  const location = useLocation();
  const [searchFilters, setParam] = useContext(SearchContext);

  const handleCategoryClick = (category: PostCategory) => {
    if (location.pathname !== withPrefix('/search')) {
      navigate(`/search?category=${category.slug}`);
    } else {
      setParam("category", category.slug);
    }
  };

  useEffect(() => {
    const countResults = categories.map(item => {
      return countPostsInCategory(item.slug);
    });
    Promise.all(countResults).then(values => {
      values.forEach((value, index) => {
        categories[index].count = value || 0;
      });
      setCategories([...categories]);
    });
  }, []);

  return (
    <React.Fragment>
      <List>
        {categories.map((item, index) => {
          return (
            <React.Fragment key={index}>
              {item.count ? (
                <List.Item style={{ cursor: 'pointer' }}>
                  <div
                    onClick={() => handleCategoryClick(item)}
                    style={{ width: '100%' }}
                  >
                    <ListItemCount
                      name={item.name || ''}
                      count={item.count || 0}
                      isHighlighted={
                        item.slug ===
                        (searchFilters.category && searchFilters.category.slug)
                      }
                    />
                  </div>
                </List.Item>
              ) : null}
            </React.Fragment>
          );
        })}
      </List>
    </React.Fragment>
  );
};

export default CategoryListContainer;
